import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import styles from './CollapsibleTrigger.module.scss';
import { Trigger, TriggerProps } from './Trigger';

export interface CollapsibleTriggerProps {
  title                         : string;
  actions                       : TriggerProps[];
  width?                        : string;
  collapsibleBackgroundColor?   : string;
  collapsibleForegroundColor?   : string;
  titleBackgroundColor?         : string;
  titleForegroundColor?         : string;
  titleBackgroundHoverColor?    : string;
  titleForegroundHoverColor?    : string;
}

export const CollapsibleTrigger = ({
  title,
  actions,
  width                      = '100%',
  collapsibleBackgroundColor = '#333',
  collapsibleForegroundColor = 'white',
  titleBackgroundColor       = '#444',
  titleForegroundColor       = 'white',
  titleBackgroundHoverColor  = '#555',
  titleForegroundHoverColor  = '#ddd',
}: CollapsibleTriggerProps) => {

  const [isExpanded,    setIsExpanded   ] = useState(false);
  const [isTitleHovered, setIsTitleHovered] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleClick = () => setIsExpanded(!isExpanded);

  return (
    <div
      className = {classNames(styles.root)}
      style     = {{
        width,
        backgroundColor                : collapsibleBackgroundColor,
        color                          : collapsibleForegroundColor,
        '--collapsible-title-bg'       : titleBackgroundColor,
        '--collapsible-title-fg'       : titleForegroundColor,
        '--collapsible-title-bg-hover' : titleBackgroundHoverColor,
        '--collapsible-title-fg-hover' : titleForegroundHoverColor,
      } as React.CSSProperties}
    >
      <div
        className    = {classNames(styles.title)}
        onClick      = {handleClick}
        onMouseEnter = {() => setIsTitleHovered(true)}
        onMouseLeave = {() => setIsTitleHovered(false)}
        style        = {{
          backgroundColor : isTitleHovered ? titleBackgroundHoverColor : titleBackgroundColor,
          color           : isTitleHovered ? titleForegroundHoverColor : titleForegroundColor,
        }}
      >
        {title}
      </div>

      <div
        ref       = {contentRef}
        className = {classNames(styles.actions, { [styles.expanded]: isExpanded })}
      >
        {actions.map((action, index) => (
          <Trigger
            key                           = {index}
            name                          = {action.name}
            onClick                       = {action.onClick}
            iconName                      = {action.iconName}
            iconPosition                  = {action.iconPosition}
            variant                       = {action.variant}
            classNameNormal               = {action.classNameNormal}
            classNamePushed               = {action.classNamePushed}
            isActive                      = {action.isActive}
            width                         = {action.width}
            height                        = {action.height}
            padding                       = {action.padding}
            margin                        = {action.margin}
            buttonForegroundColor         = {action.buttonForegroundColor}
            buttonBackgroundColor         = {action.buttonBackgroundColor}
            buttonBackgroundHoverColor    = {action.buttonBackgroundHoverColor}
            buttonForegroundHoverColor    = {action.buttonForegroundHoverColor}
            buttonBackgroundSelectedColor = {action.buttonBackgroundSelectedColor}  // ✅ Nouveau
            buttonForegroundSelectedColor = {action.buttonForegroundSelectedColor}  // ✅ Nouveau
            buttonBackgroundDisabledColor = {action.buttonBackgroundDisabledColor}
            buttonForegroundDisabledColor = {action.buttonForegroundDisabledColor}
          />
        ))}
      </div>
    </div>
  );
};

export default CollapsibleTrigger;